export default __webpack_public_path__ + "static/media/h28koritu.c6ac4dd2.mp3";